.header {
  position: sticky;
  top: 0;
  z-index: 100;
  height: var(--header-height);
  background: transparent;
  border-bottom: 1px solid transparent;
  transition:
    background var(--transition-med),
    border-color var(--transition-med),
    backdrop-filter var(--transition-med),
    box-shadow var(--transition-med);
}

.scrolled {
  background: var(--header-bg);
  backdrop-filter: blur(14px);
  border-bottom-color: var(--color-border);
  box-shadow: var(--shadow-sm);
}

.inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4);
  height: 100%;
}

.mark {
  display: inline-flex;
  align-items: center;
  height: var(--control-height);
  text-decoration: none;
  color: var(--color-text);
  line-height: 1;
  flex-shrink: 0;
  position: relative;
}

.mark:hover {
  color: var(--color-accent);
}

.mark:hover .prompt {
  color: var(--color-accent);
}

.markName {
  display: inline-flex;
  align-items: center;
  font-family: var(--font-mono);
  font-weight: 500;
  font-size: 0.95rem;
  letter-spacing: -0.01em;
  white-space: nowrap;
  color: var(--color-text);
  transition: color var(--transition-med);
}

.mark:hover .markName {
  color: var(--color-accent);
}

.prompt {
  color: var(--color-accent);
  margin-right: 0.05em;
  transition: color var(--transition-med);
}

.cursor {
  display: inline-block;
  width: 0.55ch;
  height: 1.05em;
  margin-left: 0.1em;
  background: currentColor;
  animation: blink 1.1s step-end infinite;
  vertical-align: text-bottom;
}

@keyframes blink {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}

.desktopNav {
  display: none;
}

.actions {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  flex-shrink: 0;
}

.navList {
  display: flex;
  align-items: center;
  gap: var(--space-6);
  list-style: none;
  margin: 0;
  padding: 0;
}

.navList > li {
  margin: 0;
  display: flex;
  align-items: center;
}

.navList > li + li {
  margin-top: 0;
}

.navList a {
  position: relative;
  display: inline-flex;
  align-items: center;
  height: var(--control-height);
  padding: 0 0.2rem;
  color: var(--color-text);
  text-decoration: none;
  font-size: 0.95rem;
  font-weight: 560;
  line-height: 1;
  letter-spacing: 0.01em;
  transition: color var(--duration-fast) var(--ease-out);
}

.navList a::after {
  content: "";
  position: absolute;
  inset-inline: 0;
  bottom: 0;
  height: 2px;
  background: var(--color-accent);
  border-radius: 1px;
  opacity: 0;
  transition: opacity var(--duration-fast) var(--ease-out);
}

.navList a:hover {
  color: var(--color-accent);
}

.navList a:hover::after {
  opacity: 0.45;
}

.navList a.active {
  color: var(--color-accent);
}

.navList a.active::after {
  opacity: 1;
}

.resume {
  display: none;
  gap: 0.4rem;
}

.btnIcon {
  width: 0.95rem;
  height: 0.95rem;
}

.themeBtn,
.menuBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: var(--control-height);
  height: var(--control-height);
  padding: 0;
  border-radius: var(--radius-md);
  border: 1px solid var(--color-border);
  background: var(--color-bg-elevated);
  color: var(--color-text);
  line-height: 1;
  transition:
    border-color var(--duration-fast) var(--ease-out),
    color var(--duration-fast) var(--ease-out);
}

.themeBtn:hover,
.menuBtn:hover {
  border-color: var(--color-border-strong);
  color: var(--color-accent);
}

.iconWrap {
  display: inline-flex;
  line-height: 0;
}

.icon {
  width: 1.1rem;
  height: 1.1rem;
}

.mobilePanel {
  position: absolute;
  inset-inline: 0;
  top: var(--header-height);
  background: var(--color-bg-elevated);
  border-bottom: 1px solid var(--color-border);
  box-shadow: var(--shadow-md);
  padding: var(--space-3) var(--container-padding) var(--space-4);
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transform: translateY(-6px);
  transition:
    opacity var(--duration-fast) var(--ease-in),
    transform var(--duration-fast) var(--ease-in),
    visibility var(--duration-fast);
}

.mobileOpen {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
  transform: translateY(0);
  transition:
    opacity var(--duration-normal) var(--ease-out),
    transform var(--duration-normal) var(--ease-out),
    visibility var(--duration-normal);
}

.mobileList {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 0;
}

.mobileList > li {
  margin: 0;
}

.mobileList > li + li {
  margin-top: 0;
}

.mobileList a {
  display: flex;
  align-items: center;
  min-height: 2.75rem;
  padding: var(--space-2) 0;
  text-decoration: none;
  color: var(--color-text);
  font-weight: 560;
  font-size: 1.05rem;
  border-bottom: 1px solid var(--color-border);
}

.mobileList li:last-child a {
  border-bottom: 0;
}

.mobileList a.active {
  color: var(--color-accent);
}

@media (prefers-reduced-motion: reduce) {
  .header,
  .markName,
  .prompt,
  .navList a,
  .navList a::after,
  .themeBtn,
  .menuBtn,
  .mobilePanel {
    transition: none;
  }

  .cursor {
    animation: none;
    opacity: 1;
  }

  .mobilePanel {
    opacity: 1;
    transform: none;
  }
}

@media (min-width: 900px) {
  .inner {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    justify-content: unset;
  }

  .mark {
    justify-self: start;
  }

  .desktopNav {
    display: block;
    justify-self: center;
  }

  .actions {
    justify-self: end;
  }

  .resume {
    display: inline-flex;
  }

  .menuBtn {
    display: none;
  }

  .mobilePanel {
    display: none !important;
  }
}
